export default __webpack_public_path__ + "static/media/prometheus.5a572630.svg";